import { Component, Input, OnDestroy, ElementRef, ViewChild, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from '../../user';
import { AuthService } from '../../auth.service';
import { AuthState } from '../../auth-state';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { AbstractForm } from 'src/app/shared/utils/abstract-form';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { HomeController } from 'src/app/modules/home/home.controller';

declare var $:any;

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignInComponent extends AbstractForm implements OnInit, OnDestroy {

  @ViewChild('password', {static:true}) password:ElementRef;
  @HostBinding('className') className = '';
  
  _show: boolean;
  submitted: boolean;
  showStates = [AuthState.SIGN_IN, AuthState.SIGNED_OUT, AuthState.SIGNED_UP];

  folderAssets = '';

  messageSubscription:Subscription;
  message = '';
  error = false;
  lastCode = null;

  @Input() data:any = {};

  constructor(
    protected formBuilder: FormBuilder,
    logger: LoggerService,
    private cdr: ChangeDetectorRef,
    protected authService : AuthService,
    private control: HomeController,
    protected router: Router) {
      super(formBuilder, logger, false);

      this.folderAssets = this.control.gs.getAssetsFolder();
    

  }

  ngOnInit(){
    this.messageSubscription = this.authService.messages$.subscribe(msg => {
      this.lastCode = msg?.code;
      this.error = ['authenticating','authenticated','needAuthenticate','passwordFormat'].indexOf(msg?.code) == -1;
      this.message = msg?.msg || '';
      this.setControlValue('password','');
      this.cdr.detectChanges();  
    });
    
    if(this.data?.email){
      this.setControlValue('username',this.data.email);
      this.getControl('username').disable();
      $('.inputPassword').focus();
    }
  }

  ngOnDestroy(){
    this.messageSubscription.unsubscribe();
  }

  @Input()
  set authState(authState: AuthState) {

    this._show = this.showStates.filter(item => item === authState.state).length > 0;
    if(this._show && !this.authService.getMessage()?.notReset && ['needAuthenticate','passwordFormat'].indexOf(this.lastCode) == -1)
      this.authService.setMessage('');

    this.formDefault();
    this.className = this._show? 'active' : '';

  }

  buildFormGroup(): FormGroup {

    return this.formBuilder.group({
      username: [this.data?.email || '', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(16)]]
    });

  }
  updateControls() {}
  updateObject():any {}

  getUser(): User {
    const u = new User();
    u.username = this.getControlValue('username');
    u.password = this.getControlValue('password');
    return u;
  }

  onSignIn() {
    if (this.formGroup.invalid)
      return;
    
    this.submitted = true;
    this.authService.signIn(this.getUser())
      .then(() => { })
      .catch((err) => {
        this.password.nativeElement.value = '';
      })
      .finally(() => this.submitted = false ); 
  }

  onForgotPassword() {
    this.authService.changeAuthState(AuthState.FORGOT_PASSWORD, this.getUser());
  }

  onSignUp() {
    this.router.navigate(['openModal','SignUpComponent']);
    //this.authService.changeAuthState(AuthState.SIGN_UP, this.getUser());
  }
}
